import axios from "axios";
import { gapi } from "./api.js";
import str from "../index.js";

const url = gapi + "roleAccess";

const buses = {
  namespaced: true,
  state: {
    roleAll: [],
  },
  getters: {
    GET_ALLDATA: (state) => {
      return state.roleAll;
    },
    getTodoById: (state) => (id) => {
      return state.roleAll.find((todo) => todo.id == id);
    },
  },
  mutations: {
    SET_DATA(state, data) {
      state.roleAll = data;
    },

    ADD_DATA(state, data) {
      state.roleAll.unshift(data);
    },

    UPDATE_DATA(state, data) {
      const index = state.roleAll.findIndex((t) => t.id === data.id);

      var dts = {
        id: data.id,
        roleName: data.roleName,
        std_Main: data.std_Main,
        std_add: data.std_add,
        std_update: data.std_update,
        std_delete: data.std_delete,
        std_print: data.std_print,
        driver_Main: data.driver_Main,
        driver_add: data.driver_add,
        driver_update: data.driver_update,
        driver_delete: data.driver_delete,
        driver_print: data.driver_print,
        bus_Main: data.bus_Main,
        bus_add: data.bus_add,
        bus_update: data.bus_update,
        bus_delete: data.bus_delete,
        bus_print: data.bus_print,
        busM_Main: data.busM_Main,
        busM_add: data.busM_add,
        busM_update: data.busM_update,
        busM_delete: data.busM_delete,
        busM_print: data.busM_print,
        busF_Main: data.busF_Main,
        income_Main: data.income_Main,
        income_add: data.income_add,
        income_update: data.income_update,
        income_delete: data.income_delete,
        income_print: data.income_print,
        outcome_Main: data.outcome_Main,
        outcome_add: data.outcome_add,
        outcome_update: data.outcome_update,
        outcome_delete: data.outcome_delete,
        Report_subscribe: data.Report_subscribe,
        Report_driverAccounts: data.Report_driverAccounts,
        Report_depitByBus: data.Report_depitByBus,
        Report_creditByBus: data.Report_creditByBus,
        Report_paymentsStd: data.Report_paymentsStd,
        classes_Main: data.classes_Main,
        classes_add: data.classes_add,
        classes_update: data.classes_update,
        classes_delete: data.classes_delete,
        cities_Main: data.cities_Main,
        cities_add: data.cities_add,
        cities_update: data.cities_update,
        cities_delete: data.cities_delete,
        district_Main: data.district_Main,
        district_add: data.district_add,
        district_update: data.district_update,
        district_delete: data.district_delete,
        college_Main: data.college_Main,
        college_add: data.college_add,
        college_update: data.college_update,
        college_delete: data.college_delete,
        user_Main: data.user_Main,
        user_add: data.user_add,
        user_update: data.user_update,
        user_delete: data.user_delete,
        role_Main: data.role_Main,
        role_add: data.role_add,
        role_update: data.role_update,
        role_delete: data.role_delete,
      };
      if (index !== -1) {
        state.roleAll.splice(index, 1, dts);
      }
    },
    DELETE_DATA(state, data) {
      state.roleAll = state.roleAll.filter((t) => data.id !== t.id);
    },
  },
  actions: {
    async fetchData({ commit }) {
      await axios
        .get(url, { headers: { Authorization: str.state.token } })
        .then((res) => {
          commit("SET_DATA", res.data.data);
          // console.log(res.data.data)
        })
        .catch((error) => console.log(error));
    }, // get all data view with reletion

    // add student
    async addData({ commit }, data) {
      await axios
        .post(url, data, { headers: { Authorization: str.state.token } })
        .then((res) => {
          commit("ADD_DATA", res.data.data);
        })
        .catch((error) => console.log(error));
    },
    // get student to edit
    async getData(id) {
      await axios
        .get(url + "/" + id, { headers: { Authorization: str.state.token } })
        .then((res) => {
          return res.data.data;
        })
        .catch((error) => console.log(error));
    },
    // update student
    async updateData({ commit }, data) {
      var app = url + "/" + data.id;
      await axios
        .put(app, data, { headers: { Authorization: str.state.token } })
        .then(commit("UPDATE_DATA", data))
        .catch((error) => console.log(error));
    },

    async deleteData({ commit }, data) {
      var app = url + "/" + data.id;
      await axios
        .delete(app, { headers: { Authorization: str.state.token } })
        .then(commit("DELETE_DATA", data))
        .catch((error) => console.log(error));
    },
  },
};
export default buses;
